export default function replaceNullValue<T, O extends { [key: string]: T }>(
	object: O,
	value: T,
) {
	const keys = Object.keys(object) as (keyof O)[];
	const newObject = {} as Record<keyof O, T>;

	keys.forEach((key) => {
		newObject[key] = object[key] ?? value;
	});

	return newObject;
}
